var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.899953 9.06287H3.3058V15.0415C3.3058 15.9217 4.33353 16.3369 4.87855 15.6726L10.7725 8.53144C11.2863 7.90866 10.8737 6.93713 10.0951 6.93713H7.68926V0.958453C7.68926 0.0782598 6.66152 -0.336926 6.11651 0.327371L0.22258 7.46856C-0.283503 8.09134 0.129149 9.06287 0.899953 9.06287Z",
    fill: "#00A79D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.52ca320207dd3445977ecda7e28941af.svg";
export { ForwardRef as ReactComponent };